import { applicationModuleRegistry } from '@philips-internal/oswald-ui-foundation';
import { ApplicationRoute } from '../../constants/routes';

export function setupPatientDisplacement(): void {
  applicationModuleRegistry.register({
    entry: 'PATIENT_DISPLACEMENT#9101',
    id: 'PATIENT_DISPLACEMENT#9101',
    name: 'module.patient_displacement',
    route: ApplicationRoute.PATIENT_DISPLACEMENT,
    routes: [
      {
        main: true,
        name: 'function.list-of-patients',
        route: ApplicationRoute.SEARCH_PATIENT_DISPLACEMENT,
      }
    ]
  });
}
